import { useQuery } from "@apollo/client";
import { Query, vodabucksBalanceGQL } from "@onmo/graphql/graphql";

export const useVodabucksBalance = (userId?: string) => {
  const { data } = useQuery<Pick<Query, "vodabucksBalance">>(
    vodabucksBalanceGQL,
    { variables: { input: { userId: userId || "" } } },
  );

  return { vbBalance: data?.vodabucksBalance?.balance ?? 0 };
};
